export const SEARCH = {
  ADD: "ADD_SEARCH_PARAMS",
  RESET: "RESET_SEARCH_PARAMS",
};
